module.exports = __webpack_public_path__ + "img/used@2x.c64089d7.png";